import React from 'react'
import { Theme } from '@mui/material/styles'
import { WithStyles } from '@mui/styles'
import { makeStyles, withStyles } from 'tss-react/mui'

import MuiDialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import Typography from '@mui/material/Typography'

const styles = makeStyles()(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}))

export interface DialogTitleProps {
  id: string
  children: React.ReactNode
  onClose: () => void
}

export const DialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, ...other } = props
  const { classes } = styles()
  return (
    <MuiDialogTitle className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
          size="large"
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  )
}
